import { axiosInstance } from "../helper/Axios/axios";
import { loginUrl, logoutUrl } from "../helper/endpoints/api_endpoints";
import store from "../store";
import {
  login as loginAction,
  logout as logoutAction,
  setError,
} from "../user";

// Encrypt sensitive data before storing
const encryptData = (data) => {
  // Simple base64 encryption - in production use a proper encryption library
  return btoa(JSON.stringify(data));
};

// Decrypt data
const decryptData = (encryptedData) => {
  // Simple base64 decryption - in production use a proper encryption library
  try {
    return JSON.parse(atob(encryptedData));
  } catch {
    return null;
  }
};

export const isAuthenticated = () => {
  const token = localStorage.getItem("accessToken");
  const encryptedUser = localStorage.getItem("user");

  if (!token || !encryptedUser) return false;

  const user = decryptData(encryptedUser);
  return user && token ? true : false;
};

export const login = async (email, password) => {
  try {
    const response = await axiosInstance.post(loginUrl, {
      email,
      password,
    });

    const { access, refresh, designation, firstName, lastName, avatar, role } =
      response.data;

    // Store tokens
    localStorage.setItem("accessToken", access);
    localStorage.setItem("refreshToken", refresh);

    // Create and encrypt user data
    const userData = {
      email,
      designation,
      firstName,
      lastName,
      avatar,
      role,
    };
    localStorage.setItem("user", encryptData(userData));

    // Update Redux state
    store.dispatch(
      loginAction({
        email,
        designation,
        header: true,
        firstName,
        lastName,
        avatar,
        role,
      })
    );

    return { success: true };
  } catch (error) {
    console.error("Login error:", error);
    store.dispatch(setError(error.response?.data?.message || "Login failed"));
    return {
      success: false,
      error: error.response?.data?.message || "Login failed",
    };
  }
};

export const logout = async () => {
  try {
    const refreshToken = localStorage.getItem("refreshToken");

    // Call logout endpoint
    await axiosInstance.post(logoutUrl, {
      refresh_token: refreshToken,
    });

    // Clear local storage
    localStorage.clear();

    // Update Redux state
    store.dispatch(logoutAction());

    return { success: true };
  } catch (error) {
    console.error("Logout error:", error);
    // Still clear storage and state even if API call fails
    localStorage.clear();
    store.dispatch(logoutAction());
    return {
      success: false,
      error: error.response?.data?.message || "Logout failed",
    };
  }
};

// Authentication guard HOC
export const withAuth = (WrappedComponent) => {
  return (props) => {
    if (!isAuthenticated()) {
      window.location.href = "/";
      return null;
    }
    return <WrappedComponent {...props} />;
  };
};
